import toast from 'react-hot-toast';
import { useMutation } from '@tanstack/react-query';

import useUser from 'hooks/useUser';
import updateMarketing from 'api/user/updateMarketing';

const useMarketing = () => {
  const user = useUser();

  const updateMutation = useMutation({
    mutationFn: updateMarketing,
    onSuccess: (_, { marketing }) => {
      user.update({ marketing });
    },
    onError: () => {
      toast.error('변경에 실패했습니다.');
    },
  });

  const handleMarketingChange = (event: React.FormEvent<HTMLInputElement>) => {
    const { checked } = event.currentTarget;

    updateMutation.mutate({ marketing: checked });
  };

  return {
    marketing: user.data?.marketing,
    isLoading: user.isPending,
    onMarketingChange: handleMarketingChange,
  };
};

export default useMarketing;
